import { Typography, Card } from '@ecdlink/ui';
import { ChildrenPerAgeGroupProps } from './childrenperAgeGroup.types';
import * as styles from './childrenPerAgeGroup.styles';
import { differenceInCalendarMonths, isValid } from 'date-fns';
import React from 'react';

function extractDOB(child: any): string | undefined {
  if (child?.user?.dateOfBirth !== undefined) {
    return child.user.dateOfBirth;
  }
  if (child?.dateOfBirth !== undefined) {
    return child.dateOfBirth;
  }
  return undefined;
}

function parseBirthDate(dob: unknown): Date | undefined {
  if (!dob) return undefined;
  if (dob instanceof Date && isValid(dob)) {
    if (dob.getFullYear() < 2010) return undefined;
    return dob;
  }
  if (typeof dob === 'string') {
    const trimmed = dob.trim().toLowerCase();
    if (
      trimmed === '' ||
      trimmed === 'null' ||
      trimmed === 'undefined' ||
      trimmed === '1970-01-01'
    ) {
      return undefined;
    }
    const parsed = new Date(dob);
    if (
      !isValid(parsed) ||
      parsed.getFullYear() === 1970 ||
      parsed.getFullYear() < 2010
    )
      return undefined;
    return parsed;
  }
  return undefined;
}

function getChildAgeGroup(child: any): number {
  const dob = extractDOB(child);
  const birthDate = parseBirthDate(dob);

  if (!birthDate) return 4;
  const ageInMonths = differenceInCalendarMonths(new Date(), birthDate);
  if (ageInMonths < 0) return 4;
  else if (ageInMonths < 18) return 0;
  else if (ageInMonths < 36) return 1;
  else if (ageInMonths < 72) return 2;
  else return 3;
}

export const ChildrenPerAgeGroup: React.FC<ChildrenPerAgeGroupProps> = ({
  childrenForPractitionerList = [],
}) => {
  const ageCounts = [0, 0, 0, 0, 0];
  childrenForPractitionerList.forEach((child) => {
    const group = getChildAgeGroup(child);
    const dob = extractDOB(child);
    ageCounts[group]++;
  });

  const ageGroupsTop = [
    { count: ageCounts[0], label: '< 18 mths' },
    { count: ageCounts[1], label: '18 mths - 2 years' },
    { count: ageCounts[2], label: '3 - 5 years' },
  ];

  const ageGroupsBottom = [
    { count: ageCounts[3], label: '6 - 10 years' },
    { count: ageCounts[4], label: 'Unknown Age' },
  ];

  return (
    <div>
      <Card className={styles.perAgeCard} borderRaduis={'xl'} shadowSize={'md'}>
        <div className="ml-4 mt-4 pt-4">
          <Typography
            text={'Children per age group'}
            type="body"
            className="mb-4"
          />
        </div>
        <div className="mx-6">
          <div className="mb-8 flex justify-between">
            {ageGroupsTop.map((group) => (
              <div key={group.label} className="flex-1 px-4 pb-2">
                <div className="mt-4 mb-3 text-center text-4xl font-semibold text-black">
                  {group.count}
                </div>
                <Typography
                  text={group.label}
                  type="body"
                  className="mb-4 text-center"
                />
              </div>
            ))}
          </div>
          <div className="flex justify-center">
            {ageGroupsBottom.map((group) => (
              <div key={group.label} className="max-w-xs flex-1 px-12 pb-2">
                <div className="mt-4 mb-3 text-center text-4xl font-semibold text-black">
                  {group.count}
                </div>
                <Typography
                  text={group.label}
                  type="body"
                  className="mb-4 text-center"
                />
              </div>
            ))}
          </div>
        </div>
      </Card>
    </div>
  );
};
// updated with a new category for Unknown Age
